import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/paciente";

/**
 * Classe de gerenciamento de chamadas da API do Paciente
 *
 * @class
 */
export default class PacienteApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe PacienteApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns registro do paciente
   */
    LerRegistro(codPaciente: number) {

        return this.api<ApplicationModule[]>(`${controller}/LerRegistro`, {
            method: "GET",
            params: { codPaciente }
        });
    }

}